import React, { forwardRef } from 'react';
import { MdSearch } from 'react-icons/md';
import { cva } from 'class-variance-authority';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  search?: boolean;
  error?: boolean;
}

const input = cva(
  'h-10 rounded-sm border border-solid px-4 text-body-sm placeholder:text-placeholder! focus:outline focus:outline-2 focus:-outline-offset-2',
  {
    variants: {
      search: {
        true: 'pl-10',
      },
      // エラー時はフォーカスリングも danger 色に合わせる
      error: {
        true: 'border-danger bg-danger_lighten focus:outline-danger',
        false: 'border-border focus:border-primary focus:outline-primary',
      },
    },
    defaultVariants: {
      error: false,
    },
  }
);

const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { className, search, error, ...others },
  ref
) {
  return (
    <div className="relative">
      <input ref={ref} className={input({ search, error, className })} {...others} />
      {search && <MdSearch className="absolute inset-y-0 left-3 my-auto size-icon-sm text-sub" />}
    </div>
  );
});

export default Input;
